<template>
  <PageTemplate>
    <v-container class="pt-10 pb-12">
      <Title class="text-center">Boletim Médico</Title>

      <Loading v-if="loading" />

      <div v-else class="mt-8 mt-md-10">
        <v-expansion-panels
          v-if="items.length"
          accordion
          hover
          flat
          class="items"
        >
          <v-expansion-panel v-for="({ title, text }, key) in items" :key="key">
            <v-expansion-panel-header>
              <div class="text-body-1 font-weight-medium" v-if="title">
                {{ title }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-if="text" v-html="text"></div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-alert v-else type="warning" class="mt-10">
          Nenhum boletim médico adicionado até o momento.
        </v-alert>
      </div>
    </v-container>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../templates/Page.vue";
import Loading from "../widgets/Loading.vue";
import Title from "../widgets/Title.vue";

const _config = {
  mod: "medical-bulletin",
};

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  components: {
    PageTemplate,
    Loading,
    Title,
  },
};
</script>

<style lang="scss">
.items {
  &.v-expansion-panels {
    .v-expansion-panel-header {
      .v-expansion-panel-header__icon {
        .v-icon {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
